import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private darkThemeSubject = new BehaviorSubject<boolean>(document.body.classList.contains('dark-theme'));
  public isDarkTheme$ = this.darkThemeSubject.asObservable();

  setDarkTheme(isDark: boolean) {
    this.darkThemeSubject.next(isDark);
  }

  get currentValue() {
    return this.darkThemeSubject.value;
  }
}
